import React from "react"
import styled from "@emotion/styled"
import { keyframes } from "@emotion/core"
import { StaticQuery, graphql, Link } from "gatsby"
import Image from "gatsby-image"

import { breakpoints } from "utils/styles"

const SlideCenter = props => keyframes`
  0% {
    opacity:0;
    transform:translate3d(-50%,25%,0px);
    visibility:visible;
  } 0.9% {
    opacity:1;
    transform:translate3d(-50%,75%,0px);
  } 10% { 
    opacity:1;
    transform:translate3d(-50%,75%,0px);
    visibility:visible;
  } 11% {
    opacity:0;
    transform:translate3d(-50%,135%,0px);
    visibility:hidden;
  } 100% { 
    opacity:0;
    visibility:visible;
  }
`

const Container = styled(`div`)`
  padding: 50px 0 100px 0;
  position: relative;
  text-align: center;
  @media (max-width: ${breakpoints.phablet}px) {
    margin-top: 50px;
    br {
      display: none;
    }
  }
  @media (max-width: ${breakpoints.desktop}px) {
    text-align: center;
    width: 100%;
  }
  @media (max-width: ${breakpoints.mobile}px) {
    margin-top: 30px;
  }
  h1,
  h2 {
    font-family: "Avenir Next";
    /*letter-spacing: -1px;*/
    font-size: 2rem;
    line-height: 3.9rem;
    color: #222;
    z-index: 100;
    position: relative;
    margin-bottom: 0;
    @media (max-width: ${breakpoints.desktop}px) {
      font-size: 3rem;
      line-height: 2.9rem;
    }
    @media (min-width: ${breakpoints.desktop}px) {
      font-size: 4rem;
      line-height: 4.2rem;
    }
  }
  h1 {
    color: #444;
    letter-spacing: -1px;
  }
  h2 {
    color: #444;
    text-shadow: 3px 2px 5px rgba(0, 0, 0, .1);
  }
  h3 {
    font-family: "Avenir Next";
    font-size: 1rem;
    font-weight: 400;
    line-height: 60px;
    color: #222;
    z-index: 100;
    position: relative;
    @media (max-width: ${breakpoints.tablet}px) {
      font-size: 1.2rem;
      line-height: 30px;
    }
    @media (min-width: ${breakpoints.desktop}px) {
      font-size: 1.2rem;
      line-height: 2rem;
    }
    @media (max-width: ${breakpoints.mobile}px) {
      margin-top: 10px;
      font-size: 1.3rem;
      line-height: 30px;
      /*text-align:left;*/
      margin-bottom: 50px;
    }
  }
`

const Button = styled("button")`
  background-color: #ff0000; //#FF0083;
  color: #fff;
  border: 0;
  box-shadow: 0px 10px 40px -10px rgba(255, 0, 0, 0.5);
  transform: translateY(0);
  transition: all 0.2s, transform 0.5s;
  font-size: 1.1rem;
  font-weight: 700;
  font-family: "-apple-system", "BlinkMacSystemFont", "Segoe UI";
  position: relative;
  text-decoration: none;
  text-transform: uppercase;
  display: inline-block;
  padding: 1.2rem 3rem;
  border-radius: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  span {
    margin-left: 10px;
  }
`

const SlideContainer = styled.div`
  margin: auto;
  margin-top: 0;
  margin-bottom: 0;
  line-height: 1.3em;
  white-space: nowrap;
  position: relative;
  pointer-events: none;
`

const Words = styled.div`
  width: 100%;
  height: 1em;
  display: block;
  margin-top: -70px;
  margin-bottom: 100px;
  @media (max-width: ${breakpoints.desktop}px) {
    margin-top: -50px;
    margin-bottom: 90px;
  }
  span {
    position: absolute;
    opacity: 0;
    overflow: hidden;
    animation-delay: ${props => props.wait && props.wait};
    animation: ${SlideCenter} 16s linear infinite 0s;
    animation-timing-function: cubic-bezier(0.19, 0.82, 0.84, 1.06);
    @media (max-width: ${breakpoints.desktop}px) {
      animation: ${SlideCenter} 16s linear infinite 0s;
    }
  }
`

export default () => (
	<div style={{ width: `100%`, position: "relative" }}>
      <Container>
        <h1>A better phone number for </h1>
        <h2>
          <SlideContainer>
            <Words>
              <span style={{ animationDelay: ".01s" }}>creators</span>
              <span style={{ animationDelay: "2s" }}>instagramers</span>
              <span style={{ animationDelay: "4s" }}>youtubers</span>
              <span style={{ animationDelay: "6s" }}>podcasters</span>
              <span style={{ animationDelay: "8s" }}>streamers</span>
              <span style={{ animationDelay: "10s" }}>bloggers</span>
              <span style={{ animationDelay: "12s" }}>artists</span>
              <span style={{ animationDelay: "14s" }}>musicians</span>
            </Words>
          </SlideContainer>
        </h2>
        <h3>A tiny way to instantly connect with your followers via text message.</h3>
        <Link to="/sign-up">
          <Button>
            Get your number <span>→</span>
          </Button>
        </Link>
      </Container>
    </div>
)